import { Badge } from '@ui/components/Badge';

import { TournamentMode } from '@features/shared/api/typings';
import { TOURNAMENT_MODES } from '@features/shared/constants';

type Props = {
  tournament?: {
    mode: TournamentMode;
  };
};

export function TournamentModeBadge({ tournament }: Props) {
  if (!tournament) return null;

  return (
    <Badge size="m" flat>
      {TOURNAMENT_MODES[tournament.mode]}
    </Badge>
  );
}
